@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">Clientes</div>
        </div>
        <div class="d-flex flex-wrap flex-grow-1 justify-content-end">
          @if (tabSelecionada !== 'interessadosB2B') {
            <button class="btn btn-success btn_titulo mr-2" type="button" (click)="exportar()" [disabled]="exportando">{{ exportando ? 'Exportando...' : 'Exportar' }}</button>
          }
          @if (podeImportarLeads) {
            <button class="btn btn-info btn_titulo mr-2" type="button" (click)="abrirImportacaoLeads(modalImportacaoLeads)">Importar Leads</button>
          }
          <button class="btn btn-secondary btn_titulo" type="button" (click)="novoCliente()">Novo Cliente</button>
        </div>
      </div>
    </div>
    <ul ngbNav #t="ngbNav" class="nav-tabs" (navChange)="alterarAbas($event)" [(activeId)]="tabSelecionada">
      <!-- Cadastrados -->
      <li [ngbNavItem]="'cadastrados'">
        <a ngbNavLink>
          <b>Cadastrados ({{ contagemTipos.cadastrados }})</b>
        </a>
        <ng-template ngbNavContent>
          <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            <!-- Filtro -->
            <form [formGroup]="formFiltroCliente" (ngSubmit)="adicionarFiltroCliente()">
              <div class="form-row align-items-end">
                <div class="form-group col-sm-3 mb-1">
                  <label class="text-secondary"><b>Filtrar por:</b></label>
                  <select class="form-control form-control-sm" name="filtrar_cliente_por" formControlName="filtro" (change)="alterarFiltroProdutoCliente($event.target.value)">
                    @for (f of filtroClientes; track f) {
                      <option [value]="f.valor">{{ f.texto }}</option>
                    }
                  </select>
                </div>
                <div class="form-group col-sm-5 mb-1">
                  <label class="text-secondary"><b>Valor:</b></label>
                  @if (!filtroValorClienteEhSelect) {
                    <input class="form-control form-control-sm" type="text" name="filtrar_cliente_valor" [ngClass]="{ 'is-invalid': enviadoCliente && fc.valor.errors }" formControlName="valor" />
                  }
                  @if (filtroValorClienteEhSelect) {
                    <select class="form-control form-control-sm" name="filtrar_cliente_valor_select" [ngClass]="{ 'is-invalid': enviadoCliente && fc.valor.errors }" formControlName="valor">
                      <option value="">Selecione...</option>
                      @for (op of opcoesValorFiltroCliente; track op) {
                        <option [value]="op">{{ op }}</option>
                      }
                    </select>
                  }
                  @if (enviadoCliente && fc.valor.errors) {
                    <div class="erro pt-1">Valor em branco!</div>
                  }
                </div>
                <div class="col-sm-4 mb-1 d-flex align-items-end">
                  <button class="btn btn-secondary btn_filtro mr-1" type="submit">+ Adicionar Filtro</button>
                  <button class="btn btn-primary btn_filtro mr-1" type="button" (click)="aplicarFiltroClientePaginado()">
                    Aplicar@if (filtrosAtivosClientes.length > 0) {
                    <span> ({{ filtrosAtivosClientes.length }})</span>
                  }
                </button>
                <button class="btn btn-outline-secondary btn_filtro" type="button" (click)="limparTodosFiltrosClientes()">Limpar</button>
              </div>
            </div>
          </form>
          <!-- Filtros Ativos (Pills) -->
          @if (filtrosAtivosClientes.length > 0) {
            <div style="margin-bottom: 1rem; margin-top: 0.75rem;">
              <div class="d-flex flex-wrap" style="gap: 0.5rem;">
                @for (filtro of filtrosAtivosClientes; track filtro; let i = $index) {
                  <div class="badge-info d-inline-flex align-items-center" style="font-size: 0.85rem; padding: 0.45rem 0.75rem; border-radius: 1rem;">
                    <span><b>{{ obterTextoFiltroCliente(filtro.tipo) }}:</b> {{ filtro.valor }}</span>
                    <button type="button" (click)="removerFiltroCliente(i)"
                      style="background: none; border: none; color: white; cursor: pointer; padding: 0; margin-left: 0.6rem; font-size: 1rem; line-height: 1; opacity: 0.85;">
                      ✕
                    </button>
                  </div>
                }
              </div>
            </div>
          }
          <hr class="mt-2 mb-2" />
          <!-- Contador -->
          <div class="d-flex flex-wrap align-content-start justify-content-start">
            <div class="quadros_numeros_lg p-2">
              <div class="d-flex align-items-center">
                <div class="pl-2 pr-2">
                  <i class="fa fa-check-circle quadros_numeros_icones" style="color: #28a745;"></i>
                </div>
                <div class="quadros_numeros_textos">
                  {{ totalItems }}<br />Cadastrados
                </div>
              </div>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
          <!-- Dados -->
          <div class="table-responsive">
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th></th>
                  <th class="tabela_borda"></th>
                  <th class="tabela_borda"></th>
                  @if (is_master || is_diretor) {
                    <th class="text-center tabela_borda bg_tabela_info" colspan="2">Portal Compras</th>
                  }
                  <th class="tabela_borda"></th>
                  <th class="text-center tabela_borda">Dt. Cadastro</th>
                  <th class="tabela_borda">Razão Social</th>
                  <th class="tabela_borda">Cidade</th>
                  <th class="text-center tabela_borda">CNPJ/CPF</th>
                  <th class="text-center tabela_borda">Telefone</th>
                  <th class="text-center tabela_borda">Dt Correção Geo</th>
                  <th class="text-center tabela_borda">Reiniciar Geo</th>
                  <th class="text-center tabela_borda">Foto</th>
                </tr>
              </thead>
              <tbody>
                @for (cliente of clientes; track cliente) {
                  <tr>
                    <td class="text-center tabela_acao">
                      <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="alterarCliente(cliente.client_id_app)"></i>
                    </td>
                    <td class="text-center tabela_acao tabela_borda">
                      @if (cliente.is_active) {
                        <div>
                          <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Desativar" (click)="desativarCadastro(cliente.client_id_app)"></i>
                        </div>
                      }
                    </td>
                    <td class="text-center tabela_acao tabela_borda"></td>
                    @if (is_master || is_diretor) {
                      <td class="text-center tabela_acao_expandida tabela_borda bg_tabela_info">
                        @if (cliente.password_b2b == null) {
                          <div>
                            <i class="fa fa-lock btn_tabela_acao" placement="right" ngbTooltip="Liberar" (click)="liberarPortalCompras(cliente.client_id_app, true)"></i>
                          </div>
                        }
                        @if (cliente.password_b2b != null) {
                          <div>
                            <i class="fa fa-unlock btn_tabela_acao" placement="right" ngbTooltip="Bloquear" (click)="liberarPortalCompras(cliente.client_id_app, false)"></i>
                          </div>
                        }
                      </td>
                    }
                    @if (is_master || is_diretor) {
                      <td class="text-center tabela_acao_expandida tabela_borda bg_tabela_info">
                        @if (cliente.password_b2b != null) {
                          <div>
                            <i class="fa fa-refresh btn_tabela_acao" placement="right" ngbTooltip="Resetar Senha" (click)="resetarSenhaPortalCompras(cliente.client_id_app)"></i>
                          </div>
                        }
                      </td>
                    }
                    <td class="text-center tabela_acao tabela_borda">
                      @if (cliente.fone_whatss_ddd != null && cliente.fone_whatss != null) {
                        <div>
                          <i class="fa fa-whatsapp btn_tabela_acao" placement="right" ngbTooltip="Whatsapp" (click)="iniciarChat(cliente.fone_whatss_ddd, cliente.fone_whatss)"></i>
                        </div>
                      }
                    </td>
                    <td class="text-center tabela_borda">{{ cliente.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                    <td class="tabela_borda">{{ cliente.name }}</td>
                    <td class="tabela_borda">{{ cliente.cidade }}</td>
                    <td class="text-center tabela_borda">{{ cliente.client_document }}</td>
                    <td class="text-center tabela_borda">{{ cliente.phone }}</td>
                    <td class="text-center tabela_borda text-nowrap">{{ cliente.dt_correcao_posicao ? (cliente.dt_correcao_posicao | date: 'dd/MM/yyyy HH:mm:ss') : '—' }}</td>
                    <td class="text-center tabela_acao tabela_borda">
                      <button type="button" class="btn btn-link btn-sm p-0" ngbTooltip="Reiniciar Geolocalização" aria-label="Reiniciar geolocalização" (click)="reiniciarGeolocalizacaoCliente(cliente.client_id_app)"><i class="fa fa-globe" aria-hidden="true"></i></button>
                    </td>
                    <td class="text-center tabela_borda">
                      @if (cliente.foto_correcao_posicao?.trim()) {
                        <button type="button" class="btn btn-link btn-sm p-0 text-nowrap" (click)="verFotoCorrecaoGeo(cliente, fotoCorrecaoGeo)"><i class="fa fa-picture-o" aria-hidden="true"></i> Ver foto</button>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <app-pagination
            [page]="page"
            [totalPages]="totalPages"
            [totalItems]="totalItems"
            [pageSize]="pageSize"
            (pageChange)="onPageChange($event)"
            (pageSizeChange)="onPageSizeChange($event)">
          </app-pagination>
        </div>
      </ng-template>
    </li>
    <!-- Efetivados à Cadastrar -->
    <li [ngbNavItem]="'efetivados'">
      <a ngbNavLink>
        <b>Efetivados à Cadastrar ({{ contagemTipos.efetivadosACadastrar }})</b>
      </a>
      <ng-template ngbNavContent>
        <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
          <!-- Filtro -->
          <form [formGroup]="formFiltroCliente" (ngSubmit)="adicionarFiltroCliente()">
            <div class="form-row align-items-end">
              <div class="form-group col-sm-3 mb-1">
                <label class="text-secondary"><b>Filtrar por:</b></label>
                <select class="form-control form-control-sm" name="filtrar_cliente_por" formControlName="filtro" (change)="alterarFiltroProdutoCliente($event.target.value)">
                  @for (f of filtroClientes; track f) {
                    <option [value]="f.valor">{{ f.texto }}</option>
                  }
                </select>
              </div>
              <div class="form-group col-sm-5 mb-1">
                <label class="text-secondary"><b>Valor:</b></label>
                @if (!filtroValorClienteEhSelect) {
                  <input class="form-control form-control-sm" type="text" name="filtrar_cliente_valor" [ngClass]="{ 'is-invalid': enviadoCliente && fc.valor.errors }" formControlName="valor" />
                }
                @if (filtroValorClienteEhSelect) {
                  <select class="form-control form-control-sm" name="filtrar_cliente_valor_select" [ngClass]="{ 'is-invalid': enviadoCliente && fc.valor.errors }" formControlName="valor">
                    <option value="">Selecione...</option>
                    @for (op of opcoesValorFiltroCliente; track op) {
                      <option [value]="op">{{ op }}</option>
                    }
                  </select>
                }
                @if (enviadoCliente && fc.valor.errors) {
                  <div class="erro pt-1">Valor em branco!</div>
                }
              </div>
              <div class="col-sm-4 mb-1 d-flex align-items-end">
                <button class="btn btn-secondary btn_filtro mr-1" type="submit">+ Adicionar Filtro</button>
                <button class="btn btn-primary btn_filtro mr-1" type="button" (click)="aplicarFiltroClientePaginado()">
                  Aplicar@if (filtrosAtivosClientes.length > 0) {
                  <span> ({{ filtrosAtivosClientes.length }})</span>
                }
              </button>
              <button class="btn btn-outline-secondary btn_filtro" type="button" (click)="limparTodosFiltrosClientes()">Limpar</button>
            </div>
          </div>
        </form>
        <!-- Filtros Ativos (Pills) -->
        @if (filtrosAtivosClientes.length > 0) {
          <div style="margin-bottom: 1rem; margin-top: 0.75rem;">
            <div class="d-flex flex-wrap" style="gap: 0.5rem;">
              @for (filtro of filtrosAtivosClientes; track filtro; let i = $index) {
                <div class="badge-info d-inline-flex align-items-center" style="font-size: 0.85rem; padding: 0.45rem 0.75rem; border-radius: 1rem;">
                  <span><b>{{ obterTextoFiltroCliente(filtro.tipo) }}:</b> {{ filtro.valor }}</span>
                  <button type="button" (click)="removerFiltroCliente(i)"
                    style="background: none; border: none; color: white; cursor: pointer; padding: 0; margin-left: 0.6rem; font-size: 1rem; line-height: 1; opacity: 0.85;">
                    ✕
                  </button>
                </div>
              }
            </div>
          </div>
        }
        <hr class="mt-2 mb-2" />
        <!-- Contador -->
        <div class="d-flex flex-wrap align-content-start justify-content-start">
          <div class="quadros_numeros_lg p-2">
            <div class="d-flex align-items-center">
              <div class="pl-2 pr-2">
                <i class="fa fa-clock-o quadros_numeros_icones" style="color: #fd7e14;"></i>
              </div>
              <div class="quadros_numeros_textos">
                {{ totalItems }}<br />Efetivados à Cadastrar
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <!-- Dados -->
        <div class="table-responsive">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th></th>
                <th class="tabela_borda"></th>
                <th class="tabela_borda">Cód. ERP</th>
                <th class="text-center tabela_borda">Dt. Cadastro</th>
                <th class="tabela_borda">Razão Social</th>
                <th class="tabela_borda">Cidade</th>
                <th class="text-center tabela_borda">CNPJ/CPF</th>
                <th class="text-center tabela_borda">Telefone</th>
                <th class="text-center tabela_borda">Dt Correção Geo</th>
                <th class="text-center tabela_borda">Reiniciar Geo</th>
                <th class="text-center tabela_borda">Foto</th>
              </tr>
            </thead>
            <tbody>
              @for (cliente of clientes; track cliente) {
                <tr [ngClass]="{ 'cliente-integracao-erro': possuiErroIntegracao(cliente) }">
                  <td class="text-center tabela_acao">
                    <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="alterarCliente(cliente.client_id_app)"></i>
                    @if (possuiErroIntegracao(cliente)) {
                      <i class="fa fa-search btn_tabela_acao cliente-status-icone ml-2" placement="right" ngbTooltip="Consultar status" (click)="abrirStatusIntegracaoCliente(cliente, modalStatusIntegracaoCliente)"></i>
                      <i class="fa fa-refresh btn_tabela_acao cliente-reintegrar-icone ml-2" placement="right" ngbTooltip="Reintegrar cliente" (click)="reintegrarCliente(cliente)"></i>
                    }
                  </td>
                  <td class="text-center tabela_acao tabela_borda">
                    @if (cliente.is_active) {
                      <div>
                        <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Desativar" (click)="desativarCadastro(cliente.client_id_app)"></i>
                      </div>
                    }
                  </td>
                  <td class="tabela_borda">
                    <span style="font-size: 0.85rem;">{{ cliente.codigo_no_erp_do_cliente || '—' }}</span>
                  </td>
                  <td class="text-center tabela_borda">{{ cliente.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                  <td class="tabela_borda">{{ cliente.name }}</td>
                  <td class="tabela_borda">{{ cliente.cidade }}</td>
                  <td class="text-center tabela_borda">{{ cliente.client_document }}</td>
                  <td class="text-center tabela_borda">{{ cliente.phone }}</td>
                  <td class="text-center tabela_borda text-nowrap">{{ cliente.dt_correcao_posicao ? (cliente.dt_correcao_posicao | date: 'dd/MM/yyyy HH:mm:ss') : '—' }}</td>
                  <td class="text-center tabela_acao tabela_borda">
                    <button type="button" class="btn btn-link btn-sm p-0" ngbTooltip="Reiniciar Geolocalização" aria-label="Reiniciar geolocalização" (click)="reiniciarGeolocalizacaoCliente(cliente.client_id_app)"><i class="fa fa-globe" aria-hidden="true"></i></button>
                  </td>
                  <td class="text-center tabela_borda">
                    @if (cliente.foto_correcao_posicao?.trim()) {
                      <button type="button" class="btn btn-link btn-sm p-0 text-nowrap" (click)="verFotoCorrecaoGeo(cliente, fotoCorrecaoGeo)"><i class="fa fa-picture-o" aria-hidden="true"></i> Ver foto</button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <app-pagination
          [page]="page"
          [totalPages]="totalPages"
          [totalItems]="totalItems"
          [pageSize]="pageSize"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)">
        </app-pagination>
      </div>
    </ng-template>
  </li>
  <!-- Leads -->
  <li [ngbNavItem]="'leads'">
    <a ngbNavLink>
      <b>Leads ({{ contagemTipos.leads }})</b>
    </a>
    <ng-template ngbNavContent>
      <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
        <!-- Filtro -->
        <form [formGroup]="formFiltroCliente" (ngSubmit)="adicionarFiltroCliente()">
          <div class="form-row align-items-end">
            <div class="form-group col-sm-3 mb-1">
              <label class="text-secondary"><b>Filtrar por:</b></label>
              <select class="form-control form-control-sm" name="filtrar_cliente_por" formControlName="filtro" (change)="alterarFiltroProdutoCliente($event.target.value)">
                @for (f of filtroClientes; track f) {
                  <option [value]="f.valor">{{ f.texto }}</option>
                }
              </select>
            </div>
            <div class="form-group col-sm-5 mb-1">
              <label class="text-secondary"><b>Valor:</b></label>
              @if (!filtroValorClienteEhSelect) {
                <input class="form-control form-control-sm" type="text" name="filtrar_cliente_valor" [ngClass]="{ 'is-invalid': enviadoCliente && fc.valor.errors }" formControlName="valor" />
              }
              @if (filtroValorClienteEhSelect) {
                <select class="form-control form-control-sm" name="filtrar_cliente_valor_select" [ngClass]="{ 'is-invalid': enviadoCliente && fc.valor.errors }" formControlName="valor">
                  <option value="">Selecione...</option>
                  @for (op of opcoesValorFiltroCliente; track op) {
                    <option [value]="op">{{ op }}</option>
                  }
                </select>
              }
              @if (enviadoCliente && fc.valor.errors) {
                <div class="erro pt-1">Valor em branco!</div>
              }
            </div>
            <div class="col-sm-4 mb-1 d-flex align-items-end">
              <button class="btn btn-secondary btn_filtro mr-1" type="submit">+ Adicionar Filtro</button>
              <button class="btn btn-primary btn_filtro mr-1" type="button" (click)="aplicarFiltroClientePaginado()">
                Aplicar@if (filtrosAtivosClientes.length > 0) {
                <span> ({{ filtrosAtivosClientes.length }})</span>
              }
            </button>
            <button class="btn btn-outline-secondary btn_filtro" type="button" (click)="limparTodosFiltrosClientes()">Limpar</button>
          </div>
        </div>
      </form>
      <!-- Filtros Ativos (Pills) -->
      @if (filtrosAtivosClientes.length > 0) {
        <div style="margin-bottom: 1rem; margin-top: 0.75rem;">
          <div class="d-flex flex-wrap" style="gap: 0.5rem;">
            @for (filtro of filtrosAtivosClientes; track filtro; let i = $index) {
              <div class="badge-info d-inline-flex align-items-center" style="font-size: 0.85rem; padding: 0.45rem 0.75rem; border-radius: 1rem;">
                <span><b>{{ obterTextoFiltroCliente(filtro.tipo) }}:</b> {{ filtro.valor }}</span>
                <button type="button" (click)="removerFiltroCliente(i)"
                  style="background: none; border: none; color: white; cursor: pointer; padding: 0; margin-left: 0.6rem; font-size: 1rem; line-height: 1; opacity: 0.85;">
                  ✕
                </button>
              </div>
            }
          </div>
        </div>
      }
      <hr class="mt-2 mb-2" />
      <!-- Contador -->
      <div class="d-flex flex-wrap align-content-start justify-content-start">
        <div class="quadros_numeros_lg p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-user-plus quadros_numeros_icones" style="color: #17a2b8;"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ totalItems }}<br />Leads
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-3 col-sm-12">
          <label><b>Filtrar por contato:</b></label>
          <select class="form-control" [(ngModel)]="filtroContatadoInteressadoB2B" (change)="alterarFiltroContatadoInteressadoB2B()">
            <option value="todos">Todos</option>
            <option value="contatado">Contatados</option>
            <option value="nao_contatado">Não contatados</option>
          </select>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <!-- Dados -->
      <div class="table-responsive">
        <table class="table table-sm table-hover">
          <thead>
            <tr>
              <th></th>
              <th class="tabela_borda"></th>
              <th class="tabela_borda"></th>
              <th class="text-center tabela_borda">Dt. Cadastro</th>
              <th class="tabela_borda">Razão Social</th>
              <th class="tabela_borda">Cidade</th>
              <th class="text-center tabela_borda">CNPJ/CPF</th>
              <th class="text-center tabela_borda">Telefone</th>
              <th class="text-center tabela_borda">Dt Correção Geo</th>
              <th class="text-center tabela_borda">Reiniciar Geo</th>
              <th class="text-center tabela_borda">Foto</th>
            </tr>
          </thead>
          <tbody>
            @for (cliente of clientes; track cliente) {
              <tr>
                <td class="text-center tabela_acao">
                  <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="alterarCliente(cliente.client_id_app)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  @if (cliente.is_active) {
                    <div>
                      <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Desativar" (click)="desativarCadastro(cliente.client_id_app)"></i>
                    </div>
                  }
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  <i class="fa fa-check btn_tabela_acao" placement="right" ngbTooltip="Efetivar" (click)="efetivarCadastro(cliente.client_id_app)"></i>
                </td>
                <td class="text-center tabela_borda">{{ cliente.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td class="tabela_borda">{{ cliente.name }}</td>
                <td class="tabela_borda">{{ cliente.cidade }}</td>
                <td class="text-center tabela_borda">{{ cliente.client_document }}</td>
                <td class="text-center tabela_borda">{{ cliente.phone }}</td>
                <td class="text-center tabela_borda text-nowrap">{{ cliente.dt_correcao_posicao ? (cliente.dt_correcao_posicao | date: 'dd/MM/yyyy HH:mm:ss') : '—' }}</td>
                <td class="text-center tabela_acao tabela_borda">
                  <button type="button" class="btn btn-link btn-sm p-0" ngbTooltip="Reiniciar Geolocalização" aria-label="Reiniciar geolocalização" (click)="reiniciarGeolocalizacaoCliente(cliente.client_id_app)"><i class="fa fa-globe" aria-hidden="true"></i></button>
                </td>
                <td class="text-center tabela_borda">
                  @if (cliente.foto_correcao_posicao?.trim()) {
                    <button type="button" class="btn btn-link btn-sm p-0 text-nowrap" (click)="verFotoCorrecaoGeo(cliente, fotoCorrecaoGeo)"><i class="fa fa-picture-o" aria-hidden="true"></i> Ver foto</button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <app-pagination
        [page]="page"
        [totalPages]="totalPages"
        [totalItems]="totalItems"
        [pageSize]="pageSize"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)">
      </app-pagination>
    </div>
  </ng-template>
</li>
<!-- Interessados B2B -->
<li [ngbNavItem]="'interessadosB2B'">
  <a ngbNavLink>
    <b>Interessados B2B ({{ contagemTipos.interessadosB2B }})</b>
  </a>
  <ng-template ngbNavContent>
    <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
      <div class="d-flex flex-wrap align-content-start justify-content-start">
        <div class="quadros_numeros_lg p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-address-card quadros_numeros_icones" style="color: #17a2b8;"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ totalItems }}<br />Interessados B2B
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <div class="row mt-3">
        <div class="col-md-3 col-sm-12">
          <label><b>Filtrar por contato:</b></label>
          <select class="form-control" [(ngModel)]="filtroContatadoInteressadoB2B" (change)="alterarFiltroContatadoInteressadoB2B()">
            <option value="todos">Todos</option>
            <option value="contatado">Contatados</option>
            <option value="nao_contatado">Não contatados</option>
          </select>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <div class="table-responsive">
        <table class="table table-sm table-hover">
          <thead>
            <tr>
              <th class="text-center tabela_borda">Ação</th>
              <th class="tabela_borda">Razão Social</th>
              <th class="text-center tabela_borda">CPF/CNPJ</th>
              <th class="tabela_borda">E-mail</th>
              <th class="text-center tabela_borda">Telefone</th>
              <th class="text-center tabela_borda">WhatsApp</th>
              <th class="text-center tabela_borda">Preferência Contato</th>
              <th class="text-center tabela_borda">Dt. Cadastro</th>
            </tr>
          </thead>
          <tbody>
            @for (interessado of interessadosB2BPaginados; track interessado) {
              <tr [ngClass]="{ 'interessado-contatado': interessado.contatado }">
                <td class="text-center tabela_borda">
                  @if (!interessado.contatado) {
                    <button class="btn btn-sm btn-success" type="button" (click)="atualizarContatoInteressadoB2B(interessado, true)">Contatado</button>
                  }
                  @if (interessado.contatado) {
                    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="atualizarContatoInteressadoB2B(interessado, false)">Retirar contatado</button>
                  }
                </td>
                <td class="tabela_borda">{{ interessado.razao_social }}</td>
                <td class="text-center tabela_borda">{{ interessado.cnpj_cpf }}</td>
                <td class="tabela_borda">{{ interessado.email }}</td>
                <td class="text-center tabela_borda">{{ interessado.telefone }}</td>
                <td class="text-center tabela_borda">{{ interessado.whatsapp }}</td>
                <td class="text-center tabela_borda">{{ interessado.preferencia_contato }}</td>
                <td class="text-center tabela_borda">{{ interessado.data_cadastro | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <app-pagination
        [page]="page"
        [totalPages]="totalPages"
        [totalItems]="totalItems"
        [pageSize]="pageSize"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)">
      </app-pagination>
    </div>
  </ng-template>
</li>
</ul>
<div [ngbNavOutlet]="t"></div>

<ng-template #modalImportacaoLeads let-modal>
  <div class="modal-header">
    <div>
      <h4 class="modal-title mb-0">Importar Leads</h4>
      <small class="text-muted">Importe leads pela coluna client.codigo_no_erp_do_cliente informada como CNPJ/CPF.</small>
    </div>
    <button type="button" class="close" aria-label="Fechar" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="alert alert-warning">
      Limite máximo de 50 leads por importação. Se o CPF/CNPJ já existir no cadastro, o registro não será importado nem atualizado.
    </div>

    <div class="d-flex flex-wrap align-items-center mb-3">
      <button class="btn btn-outline-primary mr-2 mb-2" type="button" (click)="baixarModeloImportacaoLeads()">
        <i class="fa fa-download mr-1"></i> Baixar modelo
      </button>
      <input class="form-control-file mr-2 mb-2" type="file" accept=".xlsx,.xls" (change)="selecionarArquivoImportacaoLeads($event)" style="max-width: 420px;" />
      <button class="btn btn-success mb-2" type="button" (click)="processarImportacaoLeads()" [disabled]="importandoLeads">
        {{ importandoLeads ? 'Processando...' : 'Importar planilha' }}
      </button>
    </div>

    @if (resultadoImportacaoLeads != null) {
      <div>
        <div class="row mb-3">
          <div class="col-md-2 col-sm-6 mb-2">
            <div class="border rounded p-2 text-center">
              <div class="text-secondary"><b>Linhas</b></div>
              <div class="h4 mb-0">{{ resultadoImportacaoLeads.total_linhas || 0 }}</div>
            </div>
          </div>
          <div class="col-md-2 col-sm-6 mb-2">
            <div class="border rounded p-2 text-center">
              <div class="text-secondary"><b>Importados</b></div>
              <div class="h4 mb-0 text-success">{{ resultadoImportacaoLeads.importados || 0 }}</div>
            </div>
          </div>
          <div class="col-md-2 col-sm-6 mb-2">
            <div class="border rounded p-2 text-center">
              <div class="text-secondary"><b>Avisos</b></div>
              <div class="h4 mb-0 text-warning">{{ resultadoImportacaoLeads.importados_com_aviso || 0 }}</div>
            </div>
          </div>
          <div class="col-md-2 col-sm-6 mb-2">
            <div class="border rounded p-2 text-center">
              <div class="text-secondary"><b>Erros</b></div>
              <div class="h4 mb-0 text-danger">{{ resultadoImportacaoLeads.erros || 0 }}</div>
            </div>
          </div>
          <div class="col-md-2 col-sm-6 mb-2">
            <div class="border rounded p-2 text-center">
              <div class="text-secondary"><b>Geolocalizados</b></div>
              <div class="h4 mb-0">{{ resultadoImportacaoLeads.geolocalizados || 0 }}</div>
            </div>
          </div>
          <div class="col-md-2 col-sm-6 mb-2">
            <div class="border rounded p-2 text-center">
              <div class="text-secondary"><b>Sem geo</b></div>
              <div class="h4 mb-0">{{ resultadoImportacaoLeads.sem_geolocalizacao || 0 }}</div>
            </div>
          </div>
        </div>

        @if (resultadoImportacaoLeads.vendedores != null && resultadoImportacaoLeads.vendedores.length > 0) {
          <h6><b>Importados por vendedor</b></h6>
          <div class="table-responsive mb-3">
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th>Código vendedor</th>
                  <th>Vendedor</th>
                  <th class="text-center">Importados</th>
                </tr>
              </thead>
              <tbody>
                @for (vendedor of resultadoImportacaoLeads.vendedores; track vendedor) {
                  <tr>
                    <td>{{ vendedor.codvenderp }}</td>
                    <td>{{ vendedor.vendedor }}</td>
                    <td class="text-center">{{ vendedor.importados }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }

        <h6><b>Detalhes da importação</b></h6>
        <div class="table-responsive" style="max-height: 360px;">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th class="text-center">Linha</th>
                <th>Código vendedor</th>
                <th>Vendedor</th>
                <th>Razão Social</th>
                <th>CNPJ/CPF</th>
                <th>Status</th>
                <th>Detalhe</th>
              </tr>
            </thead>
            <tbody>
              @for (item of resultadoImportacaoLeads.itens; track item) {
                <tr>
                  <td class="text-center">{{ item.linha }}</td>
                  <td>{{ item.codvenderp }}</td>
                  <td>{{ item.vendedor }}</td>
                  <td>{{ item.razaosocial }}</td>
                  <td>{{ item.cnpj }}</td>
                  <td>
                    <span class="badge"
                      [ngClass]="{
                        'badge-success': item.status == 'Importado',
                        'badge-warning': item.status == 'Importado com aviso',
                        'badge-danger': item.status == 'Erro'
                      }">
                      {{ item.status }}
                    </span>
                  </td>
                  <td>{{ item.detalhe }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Fechar</button>
  </div>
</ng-template>

<ng-template #modalStatusIntegracaoCliente let-modal>
  <div class="modal-header">
    <div>
      <h4 class="modal-title mb-0">Status de integração do cliente</h4>
      @if (clienteStatusSelecionado) {
        <small class="text-muted">
          {{ clienteStatusSelecionado.codigo_no_erp_do_cliente }} - {{ clienteStatusSelecionado.name }}
        </small>
      }
    </div>
    <button type="button" class="close" aria-label="Fechar" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    @if (carregandoStatusIntegracao) {
      <div class="text-center text-muted p-4">Carregando status...</div>
    }
    @if (!carregandoStatusIntegracao && statusIntegracaoCliente.length == 0) {
      <div class="alert alert-info mb-0">Nenhum status encontrado para este cliente.</div>
    }
    @if (!carregandoStatusIntegracao && statusIntegracaoCliente.length > 0) {
      <div class="table-responsive">
        <table class="table table-sm table-hover mb-0">
          <thead>
            <tr>
              <th class="text-center">ID</th>
              <th>Status</th>
              <th class="text-center">Data</th>
            </tr>
          </thead>
          <tbody>
            @for (item of statusIntegracaoCliente; track item) {
              <tr>
                <td class="text-center">{{ item.id }}</td>
                <td>{{ item.status }}</td>
                <td class="text-center">{{ item.data | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</ng-template>
</div>
}

<ng-template #fotoCorrecaoGeo let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="titulo-foto-correcao-geo">Foto da correção de geolocalização</h4>
    <button type="button" class="close" aria-label="Fechar foto" (click)="modal.dismiss()"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    <p>{{ fotoCorrecaoGeoCliente }}</p>
    @if (erroFotoCorrecaoGeo) {
      <p class="text-danger" role="alert">Não foi possível carregar a foto.</p>
    } @else {
      <img class="img-fluid d-block mx-auto" [src]="fotoCorrecaoGeoUrl" [alt]="'Foto da correção de geolocalização de ' + fotoCorrecaoGeoCliente" (error)="erroFotoCorrecaoGeo = true" />
    }
  </div>
</ng-template>
